import LogRocket from 'logrocket';
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { App } from "./App";
import "./i18n";
import { returnEnvironment } from "./utils";
import { PRODUCTION_ENVIRONMENTS } from "./data/Interfaces";

const environment = returnEnvironment();

if (PRODUCTION_ENVIRONMENTS.includes(environment)) {
    LogRocket.init('cbb6ld/final-level');
}

import(`./_assets/css/${environment}/global.css`);

const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient();

root.render(
    <QueryClientProvider client={queryClient}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </QueryClientProvider>,
);
